<template>
  <div class="big doctor-Goods">
    <div class="page_title">评价管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="评价管理"
            name="1"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1464') : false
            "
          >
          </el-tab-pane>
          <el-tab-pane label="导入管理" name="2"   :disabled="
              module_id_array[0] ? !module_id_array.includes('1673') : false
            "> </el-tab-pane>
        </el-tabs>
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Evaluation from "./Evaluation.vue";
import ImportManage from "./ImportManage.vue";
export default {
  components: {
    Evaluation,
    ImportManage,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return Evaluation;
        case "2":
          return ImportManage;
        default:
          return Evaluation;
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
